export default ({ input, params }) => {
  // if function
  if (typeof input === 'function') {
    return input(params);
  }
  return input;
};
